// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\categories\category.service.js

import { apiClient } from '../apiClient';

export const CategoryService = {
  getCategories: async () => {
    const response = await apiClient.get(
      '/brickbucket/product-category/get-all-productCategories?is_ecommerce=true'
    );
    return response;
  },
};